import {
  CheckCircleOutlined,
  CheckOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  LoadingOutlined,
  StarFilled,
  StarOutlined,
} from "@ant-design/icons";

import {
  Avatar,
  Button,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Empty,
  Image,
  message,
  Modal,
  Popconfirm,
  Row,
  Select,
  Skeleton,
  Space,
  Statistic,
  TimePicker,
  Tooltip,
  Typography,
} from "antd";
import dayjs from "dayjs";
import Pusher from "pusher-js";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../assets/css/commonVessels.css";
import "../../assets/css/conversationPage.css";
import Loading from "../../assets/gif/Loading.gif";
import editIcon from "../../assets/icons/editIcon.svg";
import LabelAndValue from "../../components/custom/form/LabelAndValue";
import HToolTip from "../../components/custom/info/HToolTip";
import HButton from "../../components/custom/input/button/Button";
import Checkbox from "../../components/custom/input/checkbox/Checkbox";
import HSInput from "../../components/custom/input/input/Input";
import HSelect from "../../components/custom/input/select/Select";
import {
  ASSIST_MAIL,
  Chargebee_CHARGE_NAME,
  COMPANY_NAME,
  urlParams,
  VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY,
  VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY,
  VOICE_PLUS_MESSAGING_STARTS_AT_MONTHLY,
} from "../../constants/AppConstants";
import { ProviderCommonObj, ProviderExtendedCommonObj } from "../../constants/ProviderConstants";
import { useRolesContext } from "../../context/RolesContext";
import useAI from "../../hooks/useAI";
import useConfigurePhone from "../../hooks/useConfigurePhone";
import useHttp from "../../hooks/useHttp";
import useLicense from "../../hooks/useLicense";
import useNumbers from "../../hooks/useNumbers";
import useTemplates from "../../hooks/useTemplates";
import CommonUserAvatar from "../../voice/CommonUserAvatar";
import { useVoiceContext } from "../../voice/context/VoiceContext";
import { getCurrentFeature, getCurrentPlanName, initiateOutboundCall } from "../../voice/utils/VoiceUtils";
import { AppContext } from "./../../context/AppContext";
import { successNotification } from "./../utils/CommonNotifications";
import { RegisterChargebee } from "./ChargebeeRegistration";
import { checkIsAdmin, formatPhoneNumber, getToneSuggestionItems } from "./commonUtils";
import { getHSFormattedDateString } from "./dateUtils";
import HNotification from "../../components/custom/notification/HNotification";
import Link from "../../components/custom/info/Link";

const { Text } = Typography;

export const CommonLoading = () => {
  return (
    <div className="container-loading">
      <img
        src={Loading}
        alt="loading"
        style={{
          height: 150,
          width: 200,
          mixBlendMode: "darken",
          pointerEvents: "none",
        }}
      />
    </div>
  );
};

export const CommonSpinLoading = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "61vh", // Full viewport height
      }}
    >
      <LoadingOutlined
        data-cy="common-loading-spinner"
        spin
        style={{
          fontSize: 24,
          color: "#605BFF",
        }}
      />
    </div>
  );
};

export const ConversationListSkeletonLoading = () => {
  return (
    <div className="w-auto overflow-hidden mt-1">
      {Array.from({ length: 20 }).map((_, index) => (
        <div key={index} className="d-flex align-items-start px-1 py-3">
          <div className="chat-avatar-skeleton ms-2 my-1"></div>

          <div className="ms-2 rounded-3 flex-grow-1">
            <div className="chat-line-skeleton my-2 w-75"></div>
            <div className="chat-line-skeleton w-50"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const LicenseInvalidModal = () => {
  const [appProperties] = useContext(AppContext);
  const isModalVisible = true;
  const [open, setOpen] = useState(false);
  const { fetchStripeURL } = useLicense();
  const urlParams = new URLSearchParams(window.location.search);
  const purchased = urlParams.get("purchased");
  const handleManageSubscription = (e) => {
    if (appProperties.licenseHandledBy === "STRIPE") {
      fetchStripeURL(appProperties).then(function (stripeLink) {
        window.open(stripeLink.url, "_blank");
      });
    } else {
      appProperties.controller.pricingLink(appProperties).then(function (resp) {
        window.open(resp, "_blank");
      });
    }
  };

  const getLicenseDetails = () => {
    window.location.reload();
  };
  const planName = getCurrentPlanName(appProperties?.licenseObj?.licenseDetails?.planName);

  return (
    <>
      <div>
        <Modal
          width={400}
          className="activateLicenseModal"
          open={isModalVisible}
          footer={null}
          closable={false}
          centered
        >
          {purchased && (
            <Row className="hs-fw-500">
              <span className="actionIconsSprite refresh-icon-new  " onClick={getLicenseDetails}></span> Please refresh
              the page to stay updated
            </Row>
          )}
          <Row>
            <Col span={20}>
              <div className="d-flex align-items-left justify-content-left mt-3 mb-3">
                <div className="staticIconsSprite licenseIcon"></div>
              </div>
            </Col>
          </Row>
          <div style={{ fontSize: "16px", fontWeight: 600 }} className="mb-1 me-3">
            Get access to stay connected with client replies.
          </div>
          <div className="pb-3">
            Starts at {`${VOICE_PLUS_MESSAGING_STARTS_AT_MONTHLY}`}/month with 3 users included
          </div>
          <Row>
            <Col span={10} className="activateExtendBtn">
              <Button
                onClick={() => setOpen(true)}
                id="extendTrail"
                className="fs-6 extendTrail w-100"
                size="large"
                style={{ backgroundColor: "#F5F5F5", border: "none" }}
              >
                <span style={{ fontSize: "14px" }}>Extend Trial</span>
              </Button>
            </Col>
            <Col span={10} className="ms-4 w-100">
              <HButton buttonClassName="hs-fs-16 px-3 w-100 d" size="l" onClick={handleManageSubscription}>
                Get Access
              </HButton>
            </Col>
          </Row>
        </Modal>

        {open && (
          <Modal
            title=" "
            centered
            open={open}
            onOk={() => setOpen(false)}
            onCancel={() => setOpen(false)}
            width={1000}
            footer={null}
          >
            <div>
              <iframe
                className="iframe-popup"
                src={`https://oapps.zohobookings.com/portal-embed#/share-and-extend?Name=${appProperties?.userName}&Email=${appProperties?.currentUserEmail}`}
                frameBorder="0"
                allowFullScreen
                title="Extend Trial"
              />
            </div>
          </Modal>
        )}
      </div>
    </>
  );
};

export const UpgradeAlertPopup = (props) => {
  const { fetchData } = useHttp();
  const [appProperties, setAppProperties] = useContext(AppContext);
  const [rolesProperties] = useRolesContext();
  const [callProperties, setCallProperties] = useVoiceContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  let { upgradeAlertPopup, setUpgradeAlertPopup } = props;
  const [currentPlan, setCurrentPlan] = useState("");
  const { fetchStripeURL } = useLicense();

  useEffect(() => {
    const planName = getCurrentFeature(appProperties);
    if (planName) {
      setCurrentPlan(planName);
    }
  }, [appProperties]);

  if (!upgradeAlertPopup) return null;
  const path = location.pathname;
  // let currentUserHasUserRolePermission = isCurrentUserHasUserRolePermission(rolesProperties);
  let currentUserHasUserRolePermission = !checkIsAdmin(appProperties, rolesProperties);

  const handleRequestAccess = () => {
    setLoading(true);
    const switchToPlan = appProperties?.licenseObj?.licenseDetails?.planName.includes("Monthly")
      ? VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_MONTHLY
      : VOICE_PLUS_MESSAGING_CHARGEBEE_PLAN_YEARLY;
    if (switchToPlan) {
      fetchData(
        `license/switch/plan?switchToPlan=${switchToPlan}&enablePlanInTrialMode=true`,
        "POST",
        null,
        appProperties
      ).then((res) => {
        const response = JSON.parse(res);
        const responseData = response?.data;
        if (responseData) {
          setAppProperties((prev) => ({
            ...prev,
            licenseObj: {
              ...prev.licenseObj,
              licenseDetails: responseData?.license,
            },
          }));

          setLoading(false);
          if (path.includes("voice/dialpad") || path.includes("/sendsms")) {
            message.success(
              `Messaging and calling are now enabled for you. Start connecting with your customers effortlessly.`
            );
            setUpgradeAlertPopup(false);
          } else {
            setLoading(false);
            navigate("/settings/number/twilio_voice" + location.search);
            setUpgradeAlertPopup(false);
            setCallProperties((prev) => ({
              ...prev,
              voicePlanRequestAccess: true,
            }));
          }
        }
      });
    }
  };

  const handleManageSubscription = (e) => {
    if (appProperties.licenseHandledBy === "STRIPE") {
      fetchStripeURL(appProperties).then(function (stripeLink) {
        window.open(stripeLink.url, "_blank");
      });
    } else {
      appProperties.controller.pricingLink(appProperties).then(function (resp) {
        try {
          const baseUrl = window.location.origin;
          const url = resp.startsWith("http") ? new URL(resp) : new URL(resp, baseUrl);
          url.searchParams.set("requestedPlan", "message+call");
          window.open(url.toString(), "_blank");
        } catch (error) {
          console.error("Error constructing URL:", error, "Response:", resp);
        }
      });
    }
  };

  const modalBody = (
    <div className="d-flex justify-content-between gap-3 flex-column ">
      <div className="d-flex justify-content-center">
        <div className="actionIconsSpriteForSideBar modal-upgrade-icon" />
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <div className="d-flex justify-content-center align-items-center flex-column">
          <h5 className="hs-color-dark-blue">{`Activate ${
            currentPlan === "Message" ? "Call" : currentPlan === "Call" ? "Message" : ""
          } Capability`}</h5>
          <div className="hs-color-dark-blue">
            You're just one step away from unlocking the {COMPANY_NAME}
            {currentPlan === "Message" ? " Call" : currentPlan === "Call" ? " Message" : ""} capability! Simply{" "}
            {currentPlan !== "Call" ? "get access or " : ""}upgrade to a higher plan to get started.
            {currentPlan === "Call" && currentUserHasUserRolePermission ? " Contact your administrator" : ""}
          </div>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-between gap-2">
        {currentPlan !== "Call" && !currentUserHasUserRolePermission && (
          <div className={`${currentUserHasUserRolePermission ? "w-100" : "w-50"}`}>
            <Popconfirm
              rootClassName="w-25 get-access-popconfirm"
              placement="top"
              title="Get Access"
              description="Upgrade now and enjoy a 5-day free trial of HelloSend Call — no commitment required!"
              okText="Yes"
              onConfirm={handleRequestAccess}
            >
              <HButton type="secondary" loading={loading} buttonClassName="hs-fw-400 w-100" variant="cancel">
                Get Access
              </HButton>
            </Popconfirm>
          </div>
        )}
        {!currentUserHasUserRolePermission && (
          <div className={`${currentPlan === "Call" && "w-100"}`}>
            <HButton type="primary" buttonClassName="hs-fw-600 w-100" onClick={handleManageSubscription}>
              Manage Subscription
            </HButton>
          </div>
        )}
      </div>
    </div>
  );
  return (
    <>
      <Modal
        className="hs-h-80 d-flex align-items-center"
        width={400}
        mask={true}
        open={upgradeAlertPopup}
        modalCloseIcon={false}
        footer={false}
        closable={!path.includes("voice/dialpad")}
        onCancel={() => setUpgradeAlertPopup(false)}
      >
        {modalBody}
      </Modal>
    </>
  );
};

export const InvalidModal = (props) => {
  let title = "";
  let modalContent = "";
  let modalButton = "";
  let link = "";

  const { open = true, setOpen = () => {}, closable = false } = props;
  const location = useLocation();
  const [appProperties] = useContext(AppContext);
  let authObj = appProperties.authorizeObj;
  let leftAuth = authObj?.left?.auth?.authorized;
  let rightAuth = authObj?.right?.auth?.authorized;
  if (!leftAuth || !rightAuth) {
    title = appProperties?.authTitle;
    modalContent = appProperties?.authContent;
    modalButton = appProperties?.authButton;
    link = `/channels/textsms/${authObj?.right?.service_name}`;
    appProperties?.controller?.getUrlParamsForRedirection(true, appProperties).then(function (redirectionUrlFromApp) {
      if (redirectionUrlFromApp) {
        link += "?" + redirectionUrlFromApp;
      } else {
        link += location.search;
      }
    });
  }

  function DoAuthorization() {
    if (!leftAuth) {
      const leftAuthWindow = window.open(appProperties.authLink, "Popup", "width=700,height=700,left=350,top=100");
      const receiveMessage = (event) => {
        if (event !== undefined && event.data !== undefined) {
          let data = event.data;
          if (typeof event.data === "string") {
            data = JSON.parse?.(event.data);
          }
          if (data !== undefined && data?.data?.integId !== undefined && data?.data?.userId !== undefined) {
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set("userId", data.data.userId);
            window.history.replaceState(null, "", "?" + urlParams.toString());
            window.location.reload();
          } else if (data !== undefined && data?.data?.osyncId !== undefined) {
            window.location.reload();
          }
        }
      };
      try {
        window.addEventListener("message", receiveMessage);
        return () => {
          leftAuthWindow.close();
          window.removeEventListener("message", receiveMessage);
        };
      } catch (error) {}
    } else {
      window.open(link);
    }
  }
  return (
    <>
      <Modal width={700} open={open} footer={null} closable={closable} onCancel={() => setOpen(false)} centered>
        <Row>
          <Col xs={5} md={4} lg={4} xl={4}>
            <ClockCircleOutlined className="clockIconInModal" />
          </Col>
          <Col xs={18} md={12} lg={12} xl={12} className="activateAuthorizeModal">
            <p className="modalTitle text-dark">{title}</p>
            <p className="modalDescription text-secondary">{modalContent}</p>
          </Col>
          <Col xs={3} md={2} lg={2} xl={2}></Col>
          <Col xs={18} md={12} lg={12} xl={12} className="ModalBtn">
            <Button onClick={DoAuthorization} className="fs-6 activateBtn" type="primary" size="middle">
              <span style={{ fontSize: "1rem" }}>{modalButton}</span>
            </Button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export const ErrorModal = (props) => {
  return (
    <>
      <Modal width={700} className="errorMessageModal" open={props.showError} footer={null} closable={false} centered>
        <Row>
          <Col xs={3} md={2} lg={2} xl={2}>
            <ExclamationCircleOutlined className="exclamatoryIcon" />
          </Col>
          <Col xs={18} md={20} lg={20} xl={20} className="errorMessageModal">
            <p className="errorModalTitle">{props.errorMessage}</p>
            <p className="errorModalDescription">{props.errorDescription}</p>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export function NoticeModal({ show, handleModalCancel, handleModalConfirm, cancel }) {
  return (
    <Modal
      centered
      width={400}
      title="Important Notice"
      open={show}
      className="noticeModal"
      onCancel={cancel}
      footer={[
        <Button key="back" danger ghost className="noticeModalButton" onClick={handleModalCancel}>
          cancel
        </Button>,
        <Button key="submit" type="primary" className="noticeModalButton" onClick={handleModalConfirm}>
          confirm
        </Button>,
      ]}
    >
      Altering the SID might impact actions configured earlier. Nevertheless ,I remain interested in moving forward with
      the override.
    </Modal>
  );
}

export function EditMessageServiceId({ msgSidList, messageServiceId, friendlyName, phoneNumber, integId }) {
  const [hover, setHover] = useState(false);
  const [showSelect, setShowSelect] = useState(false);
  const [getMsgValue, setMsgValue] = useState(messageServiceId);
  const [messageServiceValue, setMessageServiceValue] = useState(null);
  const [showNotice, setShowNotice] = useState(false);
  const [finalMessageServiceId, setFinalMessageServiceId] = useState(null);
  const [msgSidLists, setMsgSidLists] = useState([]);
  const [appProperties] = useContext(AppContext);

  const { fetchData } = useHttp();

  useEffect(() => {
    if (msgSidList?.length < 1) {
      fetchData(`omessage/${integId}/numbers`, "GET", null, appProperties)
        .then((response) => {
          const responseData = JSON.parse(response);
          if (responseData?.data?.messagingServices) {
            let getMsgServicesLists = responseData.data.messagingServices;
            const msgSidsList = getMsgServicesLists.map((service) => ({
              friendlyName: service.friendlyName,
              sid: service.sid,
            }));
            setMsgSidLists(msgSidsList);
          }
        })
        .catch((err) => {});
    } else {
      setMsgSidLists(msgSidList);
    }
  }, [appProperties, fetchData, integId, msgSidList]);

  function handleServiceChange(value) {
    setMessageServiceValue(value);
  }
  function handleMsgService() {
    if (messageServiceValue === getMsgValue || messageServiceValue === finalMessageServiceId) {
      setHover(false);
      setShowSelect(false);
    } else if (messageServiceValue !== "") {
      setShowNotice(true);
    }
  }

  function editModalConfirm() {
    setShowNotice(false);

    const appData = {
      phoneNumber: phoneNumber,
      messageServiceId: getMsgValue,
      friendlyName: friendlyName,
    };
    fetchData(
      "omessage/" + integId + "/updatePhone?associatedSid=" + messageServiceValue,
      "PUT",
      appData,
      appProperties
    ).then(function (response) {
      response = JSON.parse(response);
      if (response.data.data !== undefined) {
        setFinalMessageServiceId(response.data.data.messageServiceId);
        setMsgValue(response.data.data.messageServiceId);
        setShowSelect(false);
        setHover(false);
      }
      if (response.data.errorMessage !== undefined) {
        setFinalMessageServiceId(messageServiceId);
        HNotification.notify({ type: "error", message: "Error", description: response.data.errorMessage });
        setShowSelect(false);
        setHover(false);
      }
    });
  }
  return (
    <>
      {hover === true ? (
        <>
          {showSelect === false ? (
            <div
              onMouseOut={() => {
                setHover(false);
              }}
              onClick={() => {
                setShowSelect(true);
              }}
            >
              <img
                src={editIcon}
                alt="editIcon"
                style={{
                  height: "20px",
                  width: "20px",
                  cursor: "pointer",
                }}
              />
            </div>
          ) : (
            <>
              <div>
                <Space>
                  <Select
                    className="hs-bg-off-white focus-border w-100"
                    suffixIcon={<div className="actionIconsSprite fromNumberDropDownIcon" />}
                    variant="borderless"
                    style={{ width: "10rem" }}
                    placeholder="choose Messaging Service"
                    onSelect={handleServiceChange}
                    // onMouseOut={()=>{setHover(false)}}
                  >
                    {msgSidLists?.map((value, index) => (
                      <Select.Option key={index} value={value.sid}>
                        {value.friendlyName + "(" + value.sid + ")"}
                      </Select.Option>
                    ))}
                  </Select>
                  <NoticeModal
                    show={showNotice}
                    cancel={() => {
                      setShowNotice(false);
                    }}
                    handleModalCancel={() => {
                      setShowNotice(false);
                    }}
                    handleModalConfirm={editModalConfirm}
                  />
                  <CheckCircleOutlined className="checkMsgIcon" onClick={handleMsgService} />
                  <CloseCircleOutlined
                    className="closeMsgIcon"
                    onClick={() => {
                      setShowSelect(false);
                    }}
                  />
                </Space>
              </div>
            </>
          )}
        </>
      ) : (
        <div
          onMouseOver={() => {
            setHover(true);
          }}
          onMouseOut={() => {
            setHover(false);
          }}
        >
          {finalMessageServiceId || messageServiceId}
        </div>
      )}
    </>
  );
}

export function RefreshLicenseDetails(props) {
  const { usersTabRefreshBtn } = props;
  const [appProperties, setAppProperties] = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const { fetchData } = useHttp();
  const getLicenseDetails = () => {
    setLoading(true);
    fetchData(
      `omni/license?leftServiceId=${appProperties.leftServiceId}&osyncId=${appProperties.osyncId}`,
      "GET",
      null,
      appProperties
    )
      .then((response) => {
        response = JSON.parse(response);
        var license = response.data;
        appProperties.licenseObj.licenseDetails = license;
        setAppProperties((prev) => ({ ...prev, licenseObj: license }));
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  return (
    <>
      <Button
        rootClassName="refresh-btn"
        className="actionIconsSprite refresh-icon refreshIconHover p-1"
        loading={loading}
        onClick={getLicenseDetails}
        style={{
          border: "none",
          marginTop: usersTabRefreshBtn ? "" : "2px",
          marginRight: usersTabRefreshBtn ? "" : "0px",
        }}
      ></Button>
    </>
  );
}

export const CommonLoadingV2 = () => {
  return (
    <div data-cy="initial-common-loading-spinner" className="loading d-flex justify-content-center align-items-center">
      <span />
      <span />
      <span />
    </div>
  );
};

export const NoChannelPresent = ({
  newTab,
  baseUrl = "/channels",
  message = "No channels Connected",
  buttonText = "Add Channels",
}) => {
  const [appProperties] = useContext(AppContext);
  const [channelRedirectUrl, setChannelRedirectUrl] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  urlParams.delete("sideBar");
  urlParams.delete("topBar");

  useEffect(() => {
    if (appProperties?.controller?.getUrlParamsForRedirection) {
      appProperties.controller.getUrlParamsForRedirection(true, appProperties).then(function (respUrl) {
        setChannelRedirectUrl(respUrl);
      });
    }
  }, [appProperties?.controller]);

  return (
    <div className="d-flex flex-column m-auto w-25 align-items-center">
      <div style={{ marginTop: "30%" }} className="staticIconsSprite chatIcon-sprite"></div>
      <span
        className="m-2"
        style={{
          fontSize: newTab ? 12 : 16,
          color: "#818094",
          whiteSpace: "nowrap",
        }}
      >
        {message}
      </span>
      <Button
        data-cy="addChannel-btn"
        className="rounded m-2 addChannel-btn"
        type=""
        onClick={() => {
          if (newTab) {
            window.open(baseUrl + "?" + channelRedirectUrl);
          } else {
            navigate(baseUrl + location.search);
          }
        }}
        style={{ height: 48, width: 220 }}
      >
        {buttonText}
      </Button>
    </div>
  );
};
export const LowCreditsWarning = () => {
  const [appProperties] = useContext(AppContext);
  const [BalanceCredits, setBalanceCredits] = useState(null);
  useEffect(() => {
    if (appProperties.licenseObj != null) {
      let licenseInfo = appProperties.licenseObj.licenseDetails;
      if (licenseInfo !== null && licenseInfo !== undefined) {
        setBalanceCredits(licenseInfo?.creditsPurchased - licenseInfo?.creditsConsumed);
      }
    }
  }, [appProperties.licenseObj]);
  return (
    <>
      {BalanceCredits < 10 && appProperties?.licenseObj?.licenseDetails?.creditsPurchased > 0 ? (
        <div
          className="p-1 m-3 rounded d-flex align-items-center"
          style={{
            border: "1px solid #F44336",
            backgroundColor: "#FFEBEE",
          }}
        >
          <ExclamationCircleOutlined
            className="pe-2"
            style={{
              color: "#F44336",
              fontSize: 20,
            }}
          />
          Low balance in your wallet, top up for uninterrupted service
        </div>
      ) : null}
    </>
  );
};
export const FromNumberComponent = React.memo(
  ({
    fromNumber,
    handleFromNumberChange,
    savedNumbersList,
    setSavedNumbersList,
    defaultSelectFirstOption,
    tabIndex,
    customClasses,
    disabled,
    variant = "underlined",
    type = "primary",
    ignoredServices,
    chatView,
    selectRecentFromNumber = false,
  }) => {
    const { fetchData } = useHttp();
    const [appProperties] = useContext(AppContext);
    const { getAllSavedNumbers } = useNumbers(appProperties);
    const [fromNumberSelectLoading, setFromNumberSelectLoading] = useState(true);
    const recentNumberRef = useRef(null);

    const getRecentPhoneNumber = useCallback(async () => {
      try {
        const associatedObjectType = await appProperties?.controller?.getAssociatedObjectType(appProperties);
        const associatedObjectId = await appProperties?.controller?.getAssociatedObjectId(appProperties);
        if (!associatedObjectType || !associatedObjectId) {
          return null;
        }
        let recentPhoneNumber = await fetchData(
          `user/number-mapping?module=${associatedObjectType}&recordId=${associatedObjectId}`,
          "GET",
          null,
          appProperties
        );
        recentPhoneNumber = JSON.parse(recentPhoneNumber);
        if (recentPhoneNumber.data?.success) {
          recentPhoneNumber = recentPhoneNumber.data?.data;
        }
        return recentPhoneNumber;
      } catch (error) {
        return null;
      }
    }, [fetchData]);

    const mapPhoneAndMessagingServiceObjToSavedNumber = async (phoneList, msgObjList) => {
      const recentPhoneNumber = recentNumberRef.current;
      if (msgObjList.length > 0) {
        phoneList = [
          ...(phoneList || []),
          {
            label: (
              <Divider plain style={{ margin: 0, fontSize: "12px" }} orientation="left">
                Message Service ID
              </Divider>
            ),
            value: "divider",
            disabled: true,
          },
          ...msgObjList,
        ];
      }
      if (phoneList !== undefined && phoneList.length > 0) {
        if (selectRecentFromNumber) {
          if (recentPhoneNumber) {
            handleFromNumberChange(recentPhoneNumber);
          }
        }
        if (defaultSelectFirstOption && !recentPhoneNumber) {
          const defaultPhoneNumber =
            phoneList.find((obj) => obj?.phoneNumber === appProperties?.defaultPhoneNumber)?.phoneNumber ||
            phoneList[0]?.phoneNumber;
          handleFromNumberChange(defaultPhoneNumber);
        }
        phoneList = mapDataToOption(phoneList, appProperties, setSavedNumbersList);
      } else {
        phoneList = [];
      }
      setSavedNumbersList(phoneList);
    };

    const checkIsServiceIsNotIgnored = (serviceName) => {
      return !ignoredServices?.includes(serviceName);
    };

    const removeIgnoredServicesFromPhoneList = (savedNumbers) => {
      if (ignoredServices) {
        return savedNumbers?.filter((number) => checkIsServiceIsNotIgnored(number?.serviceName));
      }
      return savedNumbers;
    };

    const handleAddPhoneClick = () => {
      if (appProperties?.osyncId) {
        appProperties?.controller?.getUrlParamsForRedirection(true, appProperties).then(function (redirectionUrl) {
          window.open("/channels/textsms?" + redirectionUrl, "_blank");
        });
      }
    };

    useEffect(() => {
      const fetchApi = async () => {
        var phoneList = [];
        var msgObjList = [];
        if (appProperties.apps) {
          const savedNumbers = appProperties.savedNumbers;
          if (savedNumbers && savedNumbers?.length > 0) {
            savedNumbers?.forEach((item) => {
              if (checkIsServiceIsNotIgnored(item.serviceName)) {
                if (item?.isMessagingService === "true") {
                  msgObjList.push(item);
                } else {
                  phoneList.push(item);
                }
              }
            });
          } else {
            try {
              const response = await getAllSavedNumbers();
              phoneList = removeIgnoredServicesFromPhoneList(response.data);
              msgObjList = removeIgnoredServicesFromPhoneList(response.messagingServices);
            } catch (error) {}
          }

          if (phoneList.length === 0) {
            handleFromNumberChange(null);
          }
          setFromNumberSelectLoading(false);
          if (selectRecentFromNumber && !recentNumberRef.current) {
            const getRecentPhone = await getRecentPhoneNumber();
            if (getRecentPhone && savedNumbers?.some((obj) => obj?.phoneNumber === getRecentPhone)) {
              recentNumberRef.current = getRecentPhone;
            }
          }
          mapPhoneAndMessagingServiceObjToSavedNumber(phoneList, msgObjList);
        }
      };
      if (appProperties?.serviceInstalled) {
        fetchApi();
      }
    }, [
      appProperties.apps,
      appProperties?.serviceInstalled,
      fetchData,
      savedNumbersList?.length,
      setSavedNumbersList,
      defaultSelectFirstOption,
      selectRecentFromNumber,
    ]);

    useEffect(() => {
      if (appProperties) {
        let numberObj = savedNumbersList?.find((obj) => obj?.phoneNumber === fromNumber);
        let rightServiceName = appProperties?.installedApps?.find(
          (obj) => obj?.integProps?.integId === numberObj?.integId
        )?.right?.service_name;
        let assignerObj1 = Object.assign({}, ProviderCommonObj, ProviderExtendedCommonObj[rightServiceName]);
        appProperties.providerCommonObj = assignerObj1;
        appProperties.rightServiceName = rightServiceName;
      }
    }, [fromNumber, appProperties]);

    return (
      <HSelect
        floatingLabel={false}
        disabled={fromNumber ? disabled : false}
        id="fromPhoneNumber"
        options={[...(mapDataToOption(savedNumbersList, appProperties, setSavedNumbersList) || [])]}
        placeholder="Select from number"
        data-cy="select-from-number"
        autoFocus
        style={{ width: "100%" }}
        size="small"
        type={type}
        tabIndex={tabIndex}
        suffixIcon={
          fromNumberSelectLoading ? (
            <div className="actionIconsSprite dropDownLoading" />
          ) : (
            <div className="actionIconsSprite fromNumberDropDownIcon" />
          )
        }
        customProps={{
          className: `hs-fs-14 rounded ${chatView ? "" : "hs-focus-border"} hs-placeholder-text ${
            customClasses || ""
          } select-variant-${variant} ant-select-${variant}`,
          value: fromNumber || null,
          onSelect: (v) => {
            if (v !== "add::::phone") {
              handleFromNumberChange(v);
            }
          },
        }}
        popupMatchSelectWidth={false}
        listEndComponent={showFooterContentForSelect("Add Phone", handleAddPhoneClick)}
        optionListMaxHeight={200}
        notFoundContent="No phone number found"
        selectSource="phone"
        variant={variant}
      />
    );
  }
);

export const SendSMSToNumberComponent = React.memo(
  ({
    toNumber,
    setToNumber,
    savedNumbersList,
    setSavedNumbersList,
    defaultSelectFirstOption,
    tabIndex,
    customClasses,
    disabled,
    setPhoneFields,
    phoneFieldConfiguration,
    setPhoneFieldConfiguration,
  }) => {
    const [appProperties, setAppProperties] = useContext(AppContext);
    const { fetchPhoneFieldsWithValues } = useTemplates();
    const [currentModule, setCurrentModule] = useState("");
    const [recordId, setRecordId] = useState("");
    const [toNumberSelectLoading, setToNumberSelectLoading] = useState(true);
    const [toPhoneNumberList, setToPhoneNumberList] = useState(null);
    const [fieldResponse, setFieldResponse] = useState();
    const [customPhoneFieldConfiguration, setCustomPhoneFieldConfiguration] = useState();
    const { fetchData } = useHttp();
    const phoneNumberRef = useRef(null);
    const { fetchPhoneFieldConfiguration } = useConfigurePhone();

    useEffect(() => {
      let phoneFieldConfig = phoneFieldConfiguration;
      if (
        !phoneFieldConfiguration?.data?.config?.secondaryPhoneApiName &&
        !phoneFieldConfiguration?.data?.config?.primaryPhoneApiName
      ) {
        phoneFieldConfig = customPhoneFieldConfiguration;
      }
      appProperties?.controller?.getAssociatedObjectType(appProperties).then(function (associatedModule) {
        if (associatedModule) {
          setCurrentModule(associatedModule);
        }
      });
      appProperties?.controller?.getAssociatedObjectId(appProperties).then(function (recordId) {
        if (recordId) {
          setRecordId(recordId);
        }
      });
      if (phoneFieldConfig?.data?.config?.secondaryPhoneLookUp || phoneFieldConfig?.data?.config?.primaryPhoneLookUp) {
        appProperties?.controller
          ?.fetchContact(fetchData, appProperties, phoneFieldConfig)
          .then(function (contactNumbersObj) {
            if (contactNumbersObj) {
              const phoneNumbers = contactNumbersObj.map((record) => record.phone).join(",");
              if (phoneNumberRef.current !== "configured") {
                setToNumber(phoneNumbers);
              }
              if (
                !phoneNumbers &&
                !phoneFieldConfiguration?.data?.config?.secondaryPhoneApiName &&
                !phoneFieldConfiguration?.data?.config?.primaryPhoneApiName
              ) {
                let currentModulePhone = toPhoneNumberList?.find((obj) => obj?.fieldValue);
                setToNumber(currentModulePhone?.fieldValue);
              }
            }
          });
      }
    }, [appProperties?.controller, phoneFieldConfiguration, fetchData, customPhoneFieldConfiguration, fieldResponse]);

    useEffect(() => {
      if (toNumber) {
        setToNumberSelectLoading(false);
        setAppProperties((prev) => ({
          ...prev,
          phone: toNumber,
        }));
      }
    }, [toNumber]);

    useEffect(() => {
      if (currentModule && recordId && appProperties?.serviceInstalled) {
        const fetchFields = async () => {
          if (currentModule && !phoneFieldConfiguration) {
            appProperties.module = currentModule;
            let configuredFields = await fetchPhoneFieldConfiguration(appProperties, "GET");
            if (configuredFields && typeof configuredFields === "string") {
              configuredFields = JSON.parse(configuredFields);
            }
            setPhoneFieldConfiguration(configuredFields);
          }
        };

        fetchPhoneFieldsWithValues(appProperties, currentModule, recordId, false).then((response) => {
          if (response) {
            if (response?.hasPhoneFieldConfiguration) {
              fetchFields();
            }
            setFieldResponse(response);
            const allPhoneFields = response?.fields?.filter((field) => field.fieldType === "phone") || [];
            setToPhoneNumberList(allPhoneFields ?? []);
            const isAllPhoneFieldValuesEmpty = allPhoneFields.every((item) => !item.fieldValue);
            if (isAllPhoneFieldValuesEmpty) {
              setToNumberSelectLoading(false);
            }
          }
        });
      }
    }, [currentModule, recordId, appProperties?.serviceInstalled]);

    useEffect(() => {
      phoneNumberRef.current = "clear";
      const isObjectEmpty = (obj) => Object.keys(obj).length === 0;
      const getFieldValue = (apiName) =>
        toPhoneNumberList?.find((item) => item?.fieldApiName?.toLowerCase() === apiName?.toLowerCase())?.fieldValue ||
        null;

      const getPhoneNumber = (lookupApiName, phoneApiName) => {
        if (lookupApiName && fieldResponse && fieldResponse?.lookups?.length > 0) {
          const phoneObjects = fieldResponse?.lookups
            ?.filter((lookup) => lookup.fieldApiName === lookupApiName) // Filter for organization
            .flatMap(
              (lookup) => lookup.fields.filter((field) => field.fieldType === "phone") // Filter for phone type
            );
          return (
            phoneObjects.find((item) => item?.fieldApiName?.toLowerCase() === phoneApiName?.toLowerCase())
              ?.fieldValue || null
          );
        } else {
          return getFieldValue(phoneApiName);
        }
      };

      const handlePhoneNumber = () => {
        const { primaryPhoneApiName, secondaryPhoneApiName, primaryPhoneLookUp, secondaryPhoneLookUp } =
          phoneFieldConfiguration?.data?.config || {};

        let phoneNumber = getPhoneNumber(primaryPhoneLookUp, primaryPhoneApiName);
        if (phoneNumber) {
          phoneNumberRef.current = "configured";
        }

        if (!phoneNumber) {
          phoneNumber = getPhoneNumber(secondaryPhoneLookUp, secondaryPhoneApiName);
        }

        if (phoneNumber) {
          setToNumberSelectLoading(false);
          setToNumber(phoneNumber);
        } else {
          handlePhoneNumberDefault();
        }
      };
      const handlePhoneNumberDefault = () => {
        const { primaryPhoneApiName, secondaryPhoneApiName, primaryPhoneLookUp, secondaryPhoneLookUp } =
          appProperties?.controller || {};
        let phoneNumber = getPhoneNumber(primaryPhoneLookUp, primaryPhoneApiName);
        if (!phoneNumber) {
          phoneNumber = getPhoneNumber(secondaryPhoneLookUp, secondaryPhoneApiName);
        }
        if (phoneNumber) {
          setToNumberSelectLoading(false);
          setToNumber(phoneNumber);
        } else {
          appProperties?.controller?.getDefaultModuleForAGivenModule(currentModule).then(function (defaultModule) {
            let defaultApiName = appProperties?.controller?.primaryPhoneApiName;
            if (!defaultApiName)
              defaultApiName = toPhoneNumberList?.find((obj) => obj?.fieldValue)?.fieldApiName ?? null;
            phoneNumber = getPhoneNumber(defaultModule?.[0], defaultApiName);
            if (phoneNumber) {
              setToNumber(phoneNumber);
            } else {
              var defaultPhoneConfig = {};
              defaultPhoneConfig.data = {};
              defaultPhoneConfig.data.config = {
                primaryPhoneApiName: appProperties?.controller?.primaryPhoneApiName,
                primaryPhoneLookUp: defaultModule?.[0],
                secondaryPhoneApiName: appProperties?.controller?.primaryPhoneApiName,
                secondaryPhoneLookUp: defaultModule?.[1],
                module: currentModule,
              };
              if (
                !phoneFieldConfiguration?.data?.config?.secondaryPhoneApiName &&
                !phoneFieldConfiguration?.data?.config?.primaryPhoneApiName
              ) {
                setCustomPhoneFieldConfiguration(defaultPhoneConfig);
              }

              if (fieldResponse && phoneFieldConfiguration && !isObjectEmpty(phoneFieldConfiguration)) {
                setToNumberSelectLoading(false);
              }
            }
          });
        }
      };

      if (fieldResponse && phoneFieldConfiguration && !isObjectEmpty(phoneFieldConfiguration)) {
        handlePhoneNumber();
      } else if (fieldResponse && appProperties?.controller) {
        handlePhoneNumberDefault();
      }
    }, [phoneFieldConfiguration, fieldResponse]);

    return (
      <Select
        disabled={disabled}
        // disabled={toPhoneNumberList && toPhoneNumberList.length > 0 ? disabled : true}
        className={`rounded h-45  ${customClasses || ""}`}
        id="fromPhoneNumber"
        value={toNumber || null}
        // value={toPhoneNumberList && toPhoneNumberList.length > 0 ? toNumber : null || null}
        options={[
          ...(constructRecipientsData(
            toPhoneNumberList,
            setToPhoneNumberList,
            recordId,
            currentModule,
            appProperties,
            setAppProperties
          ) || []),
        ]}
        // dropdownRender={(menu, index) => {
        //   console.log("debug_ddd index", menu);
        //   return <div className="bg-dark">{menu}</div>;
        // }}
        placeholder={toNumberSelectLoading ? "" : <span className="hs-color-red">No number found</span>}
        autoFocus
        style={{ width: "100%" }}
        variant="borderless"
        tabIndex={tabIndex}
        dropdownRender={(menu) => {
          return <div className="dropDownList">{menu}</div>;
        }}
        suffixIcon={
          toNumberSelectLoading ? (
            <div className="actionIconsSprite dropDownLoading" />
          ) : (
            <div className="actionIconsSprite fromNumberDropDownIcon" />
          )
        }
        notFoundContent={
          toPhoneNumberList ? (
            <NotFoundContent content="No phone field available." />
          ) : (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{
                height: "100px",
              }}
            >
              <div className="actionIconsSprite dropDownLoading" />
            </div>
          )
        }
        onSelect={(v) => {
          setToNumber(v);
        }}
      />
    );
  }
);

export const SetAsDefaultPhone = React.memo((props) => {
  const { item } = props;
  const [appProperties, setAppProperties] = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const { fetchData } = useHttp();
  const defaultPhoneNumber = appProperties?.defaultPhoneNumber;
  const isDefaultPhoneNumber = defaultPhoneNumber && item?.phoneNumber === defaultPhoneNumber;
  const handleSetDefaultNumber = (e, method) => {
    e.stopPropagation();
    setLoading(true);
    try {
      if (method === "add") {
        fetchData(
          `${item?.integId}/number/default?phoneNumber=${encodeURIComponent(item?.phoneNumber)}`,
          "PUT",
          null,
          appProperties
        ).then(function (response) {
          if (response) {
            response = JSON.parse(response);
            response = response?.data;
            if (response?.success) {
              setAppProperties((prev) => ({
                ...prev,
                defaultPhoneNumber: item?.phoneNumber,
              }));
              message.success(response?.data || "Default number Saved successfully");
            } else {
              message.error(response?.errorMessage || "Failed to save default number");
            }
          }
        });
      } else {
        fetchData(
          `${item?.integId}/number/default?phoneNumber=${encodeURIComponent(item?.phoneNumber)}&action=remove`,
          "PUT",
          null,
          appProperties
        ).then(function (response) {
          if (response) {
            response = JSON.parse(response);
            response = response?.data;
            if (response?.success) {
              message.success(response?.data || "Default number removed successfully");
              setAppProperties((prev) => ({
                ...prev,
                defaultPhoneNumber: "",
              }));
            } else {
              message.error(response?.errorMessage || "Failed to remove default number");
            }
          }
        });
      }
    } catch (error) {
      console.error("Error", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Button
        loading={loading}
        bordered={null}
        type="link"
        onClick={(e) => {
          handleSetDefaultNumber(e, isDefaultPhoneNumber ? "remove" : "add");
        }}
        className={
          item?.phoneNumber === defaultPhoneNumber ? "defaultPhoneStarred labelMode" : "defaultPhone labelMode"
        }
      >
        {item?.phoneNumber === defaultPhoneNumber ? (
          <StarFilled className="hs-color-violet hs-fs-15" />
        ) : (
          <StarOutlined className="hs-color-violet hs-fs-15" />
        )}
      </Button>
    </>
  );
});
export const mapDataToOption = (updatedPhoneObj, appProperties, setSavedNumbers, showDefaultPhoneNumber = true) => {
  if (updatedPhoneObj?.length > 0) {
    updatedPhoneObj = updatedPhoneObj.map((item) => {
      let formattedPhoneNumber = formatPhoneNumber(item.phoneNumber);

      const teamName = item.teamName || "";
      function constructDisplayText() {
        let labelName = formattedPhoneNumber;
        if (teamName) {
          labelName = teamName + " (" + formattedPhoneNumber + ")";
        } else if (item.friendlyName) {
          labelName = (item.friendlyName || "") + ` (${formattedPhoneNumber})`;
        }
        return labelName;
      }
      return {
        ...item,
        value: item.phoneNumber,
        labelText: constructDisplayText(),
        label: item?.phoneNumber ? (
          <div className="addPhone-sendsms d-flex align-items-center flex-row w-100" data-cy="addPhone-sendsms">
            <div className="w-100 d-flex align-items-center">
              <div
                className={
                  "hs-scale-08 numberlist-sprites numberlist-" +
                  appProperties?.installedApps?.find((obj) => obj?.integProps?.integId === item.integId)?.right
                    ?.service_name
                }
              ></div>
              <div className="addPhone-sendsms ps-1">
                <Tooltip title={`${formattedPhoneNumber} ${item.friendlyName ? `- ${item.friendlyName}` : ""}`}>
                  {constructDisplayText()}
                </Tooltip>
              </div>
              {showDefaultPhoneNumber && (
                <div className="hs-w-10">
                <SetAsDefaultPhone item={item} />
              </div>
              )}
            </div>
          </div>
        ) : (
          item?.label
        ),
      };
    });
  }
  return updatedPhoneObj;
};

export const constructRecipientsData = (
  toPhoneNumberList,
  setToPhoneNumberList,
  recordId,
  module,
  appProperties,
  setAppProperties
) => {
  if (toPhoneNumberList?.length > 0) {
    toPhoneNumberList = toPhoneNumberList.map((item, index) => {
      return {
        ...item,
        key: index,
        value: item.fieldValue,
        label: item?.fieldValue ? (
          <Tooltip title={item?.fieldValue} key={"recipient-number-" + index}>
            <div className="addPhone-sendsms">
              <div className="d-flex align-items-center addPhone-sendsms">
                <span>
                  {(() => {
                    let labelName = (item.fieldName || "") + ` (${item.fieldValue})`;
                    if (labelName?.length > 30) {
                      return labelName.slice(0, 30) + "...";
                    } else {
                      return labelName;
                    }
                  })()}
                </span>

                {/* <SetAsDefaultPhone item={item} /> */}
                {/* <ClickToCallButton phone={item.fieldValue} recordId={recordId} module={module} index={index} /> */}
              </div>
            </div>
          </Tooltip>
        ) : (
          item?.fieldName
        ),
      };
    });
  }
  return toPhoneNumberList;
};

export const initPusher = (fetchData, appProperties, customChannelKey) => {
  if (appProperties?.osyncId) {
    return new Promise((resolve, reject) => {
      try {
        let pusherRef = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
          cluster: process.env.REACT_APP_PUSHER_CLUSTER,
          encrypted: true,
          forceTLS: true,
          channelAuthorization: {
            customHandler: async (params, authorize) => {
              try {
                const response = await fetchData(
                  `pusher/auth?socketId=${params.socketId || ""}&channelName=${params.channelName || ""}&leftServiceId=${
                    appProperties?.leftServiceId || ""
                  }`,
                  "post",
                  null,
                  appProperties
                );
                const responseJson = JSON.parse(response);
                authorize(null, responseJson.data);
              } catch (error) {
                reject(new Error("Error authorizing Pusher channel: " + error.message));
              }
            },
          },
        });

        let channelKey = appProperties?.osyncId;
        let channelRef = null;

        if (customChannelKey) {
          channelKey += "_" + customChannelKey;
        }
        if (channelKey) {
          channelRef = pusherRef.subscribe(`private-${channelKey}`);
        }

        function disposePusher() {
          channelRef?.unbind_all();
          pusherRef?.unsubscribe(`private-${channelKey}`);
          pusherRef?.disconnect();
        }

        if (channelRef) {
          resolve({
            channel: channelRef,
            pusher: pusherRef,
            dispose: disposePusher,
          });
        } else {
          reject(new Error("Error initializing Pusher: Channel reference is undefined"));
        }
      } catch (error) {
        reject(new Error("Error initializing Pusher: " + error.message));
      }
    });
  }
};

export const formatDate = (date) => {
  return dayjs(date).format("DD MMM, YYYY h:mm a");
};

export const formatDateTimeSeconds = (date) => {
  return dayjs("2025-11-14T06:54:25.780Z").format("YYYY-MM-DD HH:mm:ss");
};

export const CountUpStatistic = ({ title, finalCount, duration }) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    let start = 0;
    const increment = finalCount / ((duration * 1000) / 70);

    const interval = setInterval(() => {
      start += increment;
      if (start >= finalCount) {
        start = finalCount;
        clearInterval(interval);
      }
      setCount(Math.floor(start));
    }, 50);

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, [finalCount, duration]);

  return <Statistic className="statistics-data" title={title} value={isNaN(count) ? 0 : count} />;
};

export const BuyFunds = () => {
  const [appProperties, setAppProperties] = useContext(AppContext);
  const [successModal, setSuccessModal] = useState(false);
  function registerAgain() {
    RegisterChargebee("Omni", appProperties, setAppProperties, setSuccessModal);
  }
  return (
    <>
      <Button
        data-cb-type="checkout"
        data-cb-item-0={Chargebee_CHARGE_NAME}
        data-cb-item-0-quantity="1"
        type="link"
        onMouseEnter={registerAgain}
      >
        Add Funds
      </Button>
      {successModal ? (
        <CreditsSuccessModal
          successModal={successModal}
          setSuccessModal={setSuccessModal}
          handleClickDomainUrl={null}
        />
      ) : null}
    </>
  );
};

export const ConfirmAlertModal = React.memo((props) => {
  const {
    onCancel,
    open,
    onConfirm,
    centered,
    alertIcon,
    titleContent,
    modalContent,
    buttonConfirm,
    buttonClassName = "",
    buttonType = "primary",
    dataCyForConfirmBtn,
    dataCyForCancelBtn,
  } = props;
  const [confirmLoading, setConfirmLoading] = useState(false);
  const handleModalConfirm = async () => {
    if (onConfirm) {
      setConfirmLoading(true);
      await onConfirm();
      setConfirmLoading(false);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onCancel={onCancel}
        centered={centered}
        width={400}
        className="campaignOverviewEdit"
        footer={
          <div className="d-flex align-items-center justify-content-between mt-3 m-2">
            <HButton
              variant="cancel"
              buttonClassName={`w-100 me-2 h-45 hs-fw-500`}
              onClick={onCancel}
              data-cy={dataCyForCancelBtn}
            >
              <span className="hs-fs-14 hs-fw-500 hs-color-text-grey-3">Cancel</span>
            </HButton>
            <HButton
              buttonClassName={`w-100 ms-2 h-45 hs-fw-600 ${buttonClassName}`}
              type={buttonType}
              onClick={handleModalConfirm}
              loading={confirmLoading}
              data-cy={dataCyForConfirmBtn}
            >
              {buttonConfirm}
            </HButton>
          </div>
        }
      >
        <Row>
          <Col span={22}>
            <div className="d-flex align-items-center p-1  ps-0">{alertIcon}</div>
          </Col>
          <Col span={2} onClick={onCancel}>
            <div className="m-2 p-1 pt-2 pe-2">
              <div className="actionIconsSprite closeIconBig me-4"></div>
            </div>
          </Col>
        </Row>
        <div style={{ fontSize: "16px", fontWeight: 600 }} className="mb-1 mt-2">
          {titleContent}
        </div>
        <div className="pb-3">{modalContent}</div>
      </Modal>
    </>
  );
});

export const ActivityDetailsModal = React.memo((props) => {
  const { data, handleClose, open } = props ?? {};
  let { createdBy: createdUser, createdOn, modifiedBy } = data ?? {};
  createdUser = {
    ...createdUser,
    date: createdOn,
    create: true,
  };
  return (
    <Modal
      centered
      title={<div className="hs-fs-18">Activity</div>}
      cancelText={null}
      footer={<></>}
      className="activityDetailsModal"
      maskClosable={true}
      closeIcon={<div onClick={handleClose} className="actionIconsSprite closeIconSmall" />}
      mask={true}
      onCancel={handleClose}
      open={open}
    >
      <div className="pb-2">
        <div className="hs-max-h-400-px overflow-auto">
          {createdUser && <ActivityDetailItem user={createdUser} />}
          {modifiedBy &&
            modifiedBy?.map((modifiedByUser) => {
              return (
                <>
                  <hr className="hs-hr" />
                  <ActivityDetailItem user={modifiedByUser} />
                </>
              );
            })}
        </div>
      </div>
    </Modal>
  );
});

const ActivityDetailItem = (props) => {
  const { user } = props;
  const [hasImageError, setHasImageError] = useState(false);
  const formattedDate = getHSFormattedDateString(user?.date);

  const handleImageError = () => {
    setHasImageError(true);
  };

  const getFirstLetter = (name) => {
    if (!name) return "";
    return name.charAt(0).toUpperCase();
  };

  const showImage = user?.iconUrl && !hasImageError;

  return (
    <Row className="mt-2 d-flex align-items-center ms-lg-1">
      <Col span={5}>
        {showImage ? (
          <img alt="sender_url" src={user?.iconUrl} onError={handleImageError} className="avatar-big-round" />
        ) : (
          <div className="avatar-big-round fw-bold hs-fs-16 hs-bg-light-orange hs-color-dark-orange d-flex justify-content-center align-items-center">
            {getFirstLetter(user?.name || user?.email)}
          </div>
        )}
      </Col>
      <Col span={9} className="activityDetailItemText">
        <div className="hs-fs-14">{user?.create ? "Created By" : "Edited by"}</div>
        <Text className="hs-fs-16 hs-fw-550 ">{user?.name || user?.email || ""}</Text>
      </Col>
      <Col span={10}>
        <Text className="hs-fs-13 text-nowrap">{formattedDate || ""}</Text>
      </Col>
    </Row>
  );
};

const ExtraComponent = ({ content }) => {
  return (
    <>
      {content && (
        <div className="d-flex justify-content-end">
          <span className="hs-fs-11 mt-1">{content}</span>
        </div>
      )}
    </>
  );
};

export const RefreshButton = React.memo((props) => {
  const { onClickFunction, loading, className = "" } = props;
  return (
    <div
      className={`actionIconsSprite refresh-icon ${loading ? "hs-spin-360-infinite" : ""} ${className}`}
      onClick={onClickFunction}
      data-cy="refresh-icon"
    />
  );
});
export const listAllAutomationRecords = (dataList, navigate) => {
  dataList = dataList?.map((obj) => {
    return {
      ...obj,
      eventUrl: (
        <Text
          key={obj?.eventUrl}
          className="d-flex w-100 align-items-center mb-0 hs-color-violet copy-icon-webhook"
          copyable={{
            text: obj?.eventUrl,
            icon: [
              <span key="copy-icon" style={{ textDecoration: "underline" }}>
                Copy URL
              </span>,
              <CheckOutlined key="copied-icon" />,
            ],
          }}
        />
      ),
      friendlyName: obj.friendlyName,
      createdTime: (
        <span>
          {formatDate(obj.createdTime)}
          {dayjs().diff(dayjs(obj.createdTime), "minute") < 5 && <span className="new-tag">New</span>}
        </span>
      ),
      key: obj.eventId,
      module: obj?.event?.split("_")?.reverse()?.join(" / "),
      fieldApiName: typeof obj?.phoneField === "string" ? obj?.phoneField : JSON.parse(obj?.phoneField),
    };
  });
  return dataList;
};
export const ConstructFieldsList = (fieldResponse) => {
  const filteredFields = fieldResponse?.fields?.filter((field) => field.fieldType === "phone");
  let filterPhoneOptionsArray = [];
  if (filteredFields) {
    filteredFields?.forEach((fieldObj) => {
      const obj = {
        ...fieldObj,
        labelText: fieldObj.fieldName,
        label: <RenderOptionLabel label={fieldObj.fieldName} />,
        value: fieldObj.fieldApiName,
        fieldValue: fieldObj.fieldApiName,
        lookupModuleFieldApiName: fieldObj?.fieldApiName,
      };
      filterPhoneOptionsArray.push(obj);
    });
    if (fieldResponse && fieldResponse?.lookups) {
      fieldResponse?.lookups?.forEach((lookupModulePhoneField) => {
        let filteredLookupFields = lookupModulePhoneField?.fields?.filter((field) => field.fieldType === "phone");

        filteredLookupFields?.forEach((lookupFieldObj) => {
          const obj = {
            ...lookupFieldObj,
            lookupModuleField: lookupModulePhoneField?.fieldName,
            lookupModuleFieldApiName: lookupModulePhoneField?.fieldApiName,
            labelText: lookupFieldObj?.fieldName,
            label: (
              <div className="marquee-container active">
                <span className="marquee-option">
                  {module === lookupModulePhoneField?.moduleName && !lookupModulePhoneField?.lookupModuleField ? (
                    lookupFieldObj?.fieldName
                  ) : (
                    <span className="text-capitalize d-flex align-items-center">
                      {lookupModulePhoneField?.fieldName?.length > 10
                        ? lookupModulePhoneField?.fieldName?.slice(0, 9)
                        : lookupModulePhoneField?.fieldName}
                      <span className="actionIconsSprite right-arrow-icon" /> {lookupFieldObj?.fieldName}
                    </span>
                  )}
                </span>
              </div>
            ),
            value: lookupFieldObj?.fieldApiName + "&&" + lookupModulePhoneField?.fieldApiName,
            fieldValue: lookupFieldObj?.fieldApiName + "&&" + lookupModulePhoneField?.fieldApiName,
          };
          filterPhoneOptionsArray.push(obj);
        });
      });
    }
  }
  return filterPhoneOptionsArray;
};
export const handleAddAutomation = async (
  valueObj,
  setAddBtnLoading,
  method,
  setDrawerOpen,
  fetchData,
  setValueObj,
  setTableData,
  appProperties,
  setWebhookUrl,
  setWebhookId
) => {
  let notificationMessage = "";

  if (
    valueObj.integId &&
    valueObj.phoneNum &&
    valueObj.fieldApiName &&
    valueObj.templateId &&
    valueObj.friendlyName &&
    valueObj?.integId &&
    valueObj.fieldApiName.length > 0
  ) {
    delete valueObj.eventUrl;
    delete valueObj.key;
    valueObj.fieldApiList = valueObj?.fieldApiName;
    delete valueObj.fieldApiName;
    setAddBtnLoading(true);
    var targetUrl;
    var targetMethod;
    if (method.current === "edit") {
      notificationMessage = "Webhook edited successfully. Review and test the changes.";
      targetUrl = `omessage/${valueObj?.integId}/webhookNotification/${valueObj?.eventId}`;
      targetMethod = "PUT";
    } else {
      notificationMessage = "Webhook configured! Automate messaging with workflow rules.";
      targetUrl = `omessage/${valueObj?.integId}/addWebhook`;
      targetMethod = "POST";
    }
    delete valueObj.createdTime;
    delete valueObj.modifiedTime;
    let response = await fetchData(targetUrl, targetMethod, valueObj, appProperties);
    if (response) {
      let data = JSON.parse(response);
      if (data?.data?.success === true) {
        successNotification(notificationMessage);
        let webhookNotificationEntity = data?.data?.data;

        webhookNotificationEntity = listAllAutomationRecords([webhookNotificationEntity]);

        let eventUrl = data?.data?.data?.eventUrl;

        setWebhookUrl(eventUrl);
        let eventId = data?.data?.data?.eventId;
        setWebhookId(eventId);
        setTableData((prev) => {
          var existingIndex = prev?.findIndex((item) => item?.eventId === valueObj?.eventId);
          if (existingIndex !== -1) {
            const newList = [...prev];
            newList[existingIndex] = webhookNotificationEntity?.[0];
            return newList;
          } else {
            return [...webhookNotificationEntity, ...prev];
          }
        });
      } else {
        HNotification.notify({
          type: "error",
          message: "Error",
          description: data?.data?.errorMessage ? data?.data?.errorMessage : "Error processing request",
        });
      }
      // setValueObj({});
      // Check if setDrawerOpen is a function or has a callback
      if (typeof setDrawerOpen === "function") {
        setDrawerOpen(false);
      }
      setAddBtnLoading(false);
    } else {
      setAddBtnLoading(false);
    }
  } else {
    const fieldsObj = {
      friendlyName: "Friendly name is empty",
      integId: "From number is not valid",
      phoneNum: "From number is not valid",
      fieldApiName: "Selected field is not valid",
      templateId: "Selected template is not valid",
    };
    const fields = Object.keys(fieldsObj);
    const nullField = fields.find((field) => {
      const value = valueObj[field];
      return !value || value?.length < 1;
    });
    if (nullField) {
      HNotification.notify({ type: "error", message: "Error", description: `${fieldsObj[nullField]} ! ` });
    }
  }
};
export const handleBuyNumberClick = async (
  appProperties,
  setAppProperties,
  fetchData,
  setBuyNumberLoading,
  setShowBuyNumber,
  navigate,
  serviceName
) => {
  const currentParams = new URLSearchParams(window.location.search);
  const newParams = currentParams.toString();

  let savedNumbers = appProperties?.savedNumbers;
  const integrationId = appProperties?.installedApps?.find((app) => app?.right?.service_name === serviceName)
    ?.integProps?.integId;
  let helloSendNumbers = savedNumbers?.filter(
    (obj) => obj?.integId === integrationId && obj?.isHelloSendPhoneNumber === "true"
  );
  if (serviceName === "hello_send" && helloSendNumbers?.length > 0) {
    navigate(`/channels/textsms/helloSend?${newParams}`);
  } else {
    return await handleServiceProcess();
  }

  async function handleServiceProcess() {
    if (appProperties.apps) {
      let queryObj = appProperties?.installedApps?.find((app) => app?.right?.service_name === serviceName);
      if (queryObj) {
        queryObj = {
          integId: queryObj?.integProps?.integId,
          serviceId: queryObj?.right?.service_id,
          isTrialAccount: queryObj?.right?.isTrialAccount,
          rightServiceName: queryObj?.right?.service_name,
          displayName: queryObj?.right?.service_display_name,
          authorized: queryObj?.right?.auth?.authorized,
        };
      }
      let queryObj2 = appProperties?.apps?.SMS?.find((app) => app.name === serviceName);
      if (queryObj2) {
        queryObj2 = {
          integId: queryObj2?.integId,
          serviceId: queryObj2?.serviceId,
          isTrialAccount: queryObj2?.isTrialAccount,
          rightServiceName: queryObj2?.name,
          displayName: queryObj2?.displayName,
          authorized: queryObj2?.authorized,
        };
      }
      let rightServiceObj = queryObj ?? queryObj2;
      let integIdNew;
      if (!rightServiceObj?.integId || !rightServiceObj?.authorized) {
        const rightServiceId = rightServiceObj?.serviceId;
        setBuyNumberLoading(true);
        if (!rightServiceObj?.integId && rightServiceId && appProperties?.leftServiceId) {
          const integrationResp = await fetchData(
            `integration/new?userId=${appProperties?.userId}`,
            "POST",
            {
              left_service_id: appProperties.leftServiceId,
              osync_id: appProperties.osyncId,
              right_service_id: rightServiceId,
            },
            appProperties
          );
          const parsedIntegrationResp = JSON.parse(integrationResp);
          integIdNew = parsedIntegrationResp?.data?.integId;
        }
        let integId = rightServiceObj.integId || integIdNew;
        if (integId && appProperties?.leftServiceId && rightServiceId) {
          let helloSendAccountId;
          await fetchData(
            `hellosend/account/${integId}/create?leftServiceId=${appProperties.leftServiceId}&rightServiceId=${rightServiceId}`,
            "POST",
            null,
            appProperties
          )
            .then(function (response) {
              try {
                if (response) {
                  response = JSON.parse(response);
                  helloSendAccountId = response?.data?.helloSendAccountId;
                  response = response?.data?.integration;
                  setAppProperties((prev) => ({
                    ...prev,
                    serviceInstalled: true,
                    randomIntegId: prev?.randomIntegId ? prev?.randomIntegId : response?.integId,
                    installedApps: [
                      ...(prev?.installedApps || []),
                      {
                        integProps: { ...response },
                        right: {
                          service_display_name: rightServiceObj?.displayName,
                          service_name: rightServiceObj?.rightServiceName,
                          auth: {
                            authorized: true,
                            url: true,
                          },
                        },
                      },
                    ],
                  }));
                  setBuyNumberLoading(false);
                  setShowBuyNumber(true);
                }
              } catch (error) {
                console.error("Error processing response:", error);
              }
            })
            .catch((err) => {
              setBuyNumberLoading(false);
            })
            .finally(() => {
              setBuyNumberLoading(false);
            });
          return { authorized: true, integId: integId, serviceInstalled: true, helloSendAccountId: helloSendAccountId };
        }
      } else {
        setShowBuyNumber(true);
      }
    }
    return { authorized: true, serviceInstalled: true };
  }
};

export const ConfigurePhone = (props) => {
  const initialValue = {
    primaryPhoneApiName: "",
    primaryPhoneLookUp: "",
    secondaryPhoneApiName: "",
    secondaryPhoneLookUp: "",
  };

  const {
    setSelectedPhoneFieldApi,
    setPhoneFieldConfiguration,
    module,
    phoneFields,
    phoneFieldConfiguration,
    setToNumber,
    toNumber,
    setPhoneFields,
    disabled,
  } = props;
  const [configurePhoneModalOpen, setConfigurePhoneModalOpen] = useState(false);
  const [addBtnLoading, setAddBtnLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [configurePhoneContentLoaded, setConfigurePhoneContentLoaded] = useState(false);
  const [fieldsList, setFieldsList] = useState(null);
  const [fieldsOption, setFieldsOption] = useState([]);
  const [selectedFields, setSelectedFields] = useState(initialValue);
  const [selectedPrimaryValue, setSelectedPrimaryValue] = useState();
  const [selectedSecondaryValue, setSelectedSecondaryValue] = useState();
  const [currentModuleReturnedByApp, setCurrentModuleReturnedByApp] = useState("");
  const { fetchData } = useHttp();
  const { fetchPhoneFieldConfiguration } = useConfigurePhone();
  const [appProperties, setAppProperties] = useContext(AppContext);
  const [selectedIds, setSelectedIds] = useState("");
  const { fetchOnlyPhoneFields } = useTemplates();

  const [loadingFields, setLoadingFields] = useState(true);

  const handleModalClose = () => {
    setConfigurePhoneModalOpen(false);
  };

  const phoneConfigurationOptions = useMemo(() => {
    const primarySecondary = [
      {
        label: "Primary phone",
        phoneApiName: "primaryPhoneApiName",
        phoneModule: "primaryPhoneLookUp",
      },
      {
        label: "Secondary phone",
        phoneApiName: "secondaryPhoneApiName",
        phoneModule: "secondaryPhoneLookUp",
      },
    ];

    return primarySecondary;
  }, [appProperties]);

  useEffect(() => {
    if (appProperties?.companyId) {
      appProperties?.controller?.getAssociatedObjectType(appProperties).then(function (associatedModule) {
        if (associatedModule) {
          setCurrentModuleReturnedByApp(associatedModule);
        }
      });
      appProperties?.controller?.getAssociatedObjectId(appProperties).then(function (associatedId) {
        if (associatedId) {
          setSelectedIds(associatedId);
        }
      });
    }
    if (module) {
      setCurrentModuleReturnedByApp(module);
      setSelectedFields(initialValue);
    }
  }, [appProperties?.companyId, module]);

  useEffect(() => {
    if (selectedFields) {
      phoneConfigurationOptions.map((obj, index) => {
        const selectedValue =
          selectedFields?.[obj?.phoneApiName] +
          `${selectedFields?.[obj?.phoneModule] ? `&&${selectedFields?.[obj?.phoneModule]}` : ""}`;
        if (obj?.phoneApiName === "primaryPhoneApiName") {
          setSelectedPrimaryValue(selectedValue);
        } else {
          setSelectedSecondaryValue(selectedValue);
        }
      });
    }
  }, [selectedFields]);

  useEffect(() => {
    if (currentModuleReturnedByApp) {
      setFieldsList(null);
    }
  }, [currentModuleReturnedByApp]);

  useEffect(() => {
    if (phoneFields) {
      setFieldsList(phoneFields);
      setConfigurePhoneContentLoaded(true);
    }
  }, [phoneFields]);
  useEffect(() => {
    if (phoneFieldConfiguration) {
      let phoneFieldEntity = phoneFieldConfiguration?.data?.config;
      if (phoneFieldEntity) {
        setSelectedFields({
          primaryPhoneApiName: phoneFieldEntity?.primaryPhoneApiName ?? "",
          primaryPhoneLookUp: phoneFieldEntity?.primaryPhoneLookUp ?? "",
          secondaryPhoneApiName: phoneFieldEntity?.secondaryPhoneApiName ?? "",
          secondaryPhoneLookUp: phoneFieldEntity?.secondaryPhoneLookUp ?? "",
        });
        setLoadingFields(false);
      } else {
        setLoadingFields(false);
      }
    }
  }, [phoneFieldConfiguration]);

  useEffect(() => {
    const fetchFields = async () => {
      if (currentModuleReturnedByApp && !phoneFieldConfiguration) {
        appProperties.module = currentModuleReturnedByApp;
        let configuredFields = await fetchPhoneFieldConfiguration(appProperties, "GET");
        if (configuredFields && typeof configuredFields === "string") {
          configuredFields = JSON.parse(configuredFields);
        }
        setPhoneFieldConfiguration(configuredFields);
      }
    };
    if (phoneFields && phoneFields?.length) {
      fetchFields();
    }
  }, [phoneFields]);

  const optionArr = useMemo(() => {
    if (!fieldsList || !currentModuleReturnedByApp) return {};
    return phoneConfigurationOptions.reduce((acc, { phoneApiName }) => {
      const filterValue = phoneApiName === "primaryPhoneApiName" ? selectedSecondaryValue : selectedPrimaryValue;
      acc[phoneApiName] = fieldsList.filter(
        ({ fieldValue, fieldId }) => fieldValue !== filterValue && fieldId !== "Hello-Send-Phone-Configuration-Rule-Id"
      );
      return acc;
    }, {});
  }, [fieldsList, currentModuleReturnedByApp, selectedSecondaryValue, selectedPrimaryValue, phoneConfigurationOptions]);

  useEffect(() => {
    setFieldsOption(optionArr);
  }, [optionArr, setFieldsOption]);

  const addPhoneFields = () => {
    if (appProperties?.randomIntegId && currentModuleReturnedByApp && appProperties.leftServiceId) {
      setAddBtnLoading(true);
      let targetUrl = `${appProperties?.randomIntegId}/modules/phone-fields?leftServiceId=${appProperties.leftServiceId}&resource=${currentModuleReturnedByApp}`;
      if (selectedIds && selectedIds.indexOf(",") === -1) {
        targetUrl += `&selectedIds=${selectedIds}`;
      }

      fetchData(
        targetUrl,
        "POST",
        {
          ...selectedFields,
          moduleName: currentModuleReturnedByApp,
        },
        appProperties
      ).then(function (response) {
        try {
          response = JSON.parse(response);

          if (response?.data?.success) {
            let integDetails = response?.data?.integrationDetails;
            if (integDetails) {
              setAppProperties((prev) => ({
                ...prev,
                phone: integDetails?.phone || "",
              }));
            }
            if (setSelectedPhoneFieldApi) {
              setSelectedPhoneFieldApi(null);
            }
            if (setPhoneFieldConfiguration) {
              setPhoneFieldConfiguration(response);
            }
            handleModalClose();
          } else {
            HNotification.notify({ type: "error", message: "Error", description: "Something went wrong !" });
          }
          setAddBtnLoading(false);
        } catch (error) {
          setAddBtnLoading(false);
        }
      });
    } else {
      setShowError(true);
    }
  };
  const configurePhoneModalBody = (
    <>
      {loadingFields ? (
        <Skeleton active />
      ) : (
        <Space className="w-100 pt-2" direction="vertical">
          {phoneConfigurationOptions.map((obj, index) => {
            return (
              <div key={index}>
                <LabelAndValue label={obj.label} />
                <Select
                  suffixIcon={<div className="actionIconsSprite fromNumberDropDownIcon" />}
                  notFoundContent={<NotFoundContent content="No phone field available." />}
                  value={
                    obj?.phoneApiName === "primaryPhoneApiName"
                      ? selectedPrimaryValue
                      : obj?.phoneApiName === "secondaryPhoneApiName"
                        ? selectedSecondaryValue
                        : null
                  }
                  options={
                    [
                      {
                        label: <span className="opacity-50">- Select -</span>,
                        value: "",
                      },
                      ...((fieldsOption &&
                        fieldsOption[obj?.phoneApiName]?.map((obj, i) => ({
                          label: (
                            <span>
                              {currentModuleReturnedByApp === obj?.moduleName && !obj?.lookupModuleField ? (
                                <span className="text-capitalize d-flex align-items-center">{obj?.fieldName}</span>
                              ) : (
                                <span className="text-capitalize d-flex align-items-center">
                                  {obj?.lookupModuleField?.length > 10
                                    ? obj?.lookupModuleField?.slice(0, 7)
                                    : obj?.lookupModuleField}
                                  <span className="actionIconsSprite right-arrow-icon" /> {obj?.fieldName}
                                </span>
                              )}
                            </span>
                          ),
                          value: obj?.fieldValue,
                        }))) ||
                        []),
                    ] || []
                  }
                  onSelect={(e) => {
                    let item = fieldsOption?.[obj?.phoneApiName]?.find((obj) => obj?.fieldValue === e);
                    setSelectedFields((prev) => {
                      const result = {
                        ...prev,
                        [obj?.phoneApiName]: item?.fieldApiName || "",
                        [obj?.phoneModule]: e?.split("&&")?.[1]
                          ? e?.split("&&")?.[1]
                          : currentModuleReturnedByApp === item?.moduleName
                            ? ""
                            : item?.lookupModuleFieldApiName || "",
                      };
                      return result;
                    });
                  }}
                  className={`hs-input-box w-100 h-44 ${showError && index === 0 && `select-field-error`}`}
                  dropdownStyle={{
                    boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.12),0px 20px 20px 0px rgba(0, 0, 0, 0.08)",
                  }}
                  variant="borderless"
                  placeholder={`- Select -`}
                  style={{ minWidth: 180, maxWidth: 300 }}
                  onFocus={() => {
                    if (index === 0) {
                      setShowError(false);
                    }
                  }}
                />
              </div>
            );
          })}

          <div className="d-flex justify-content-end">
            <Space>
              <Button
                className="mt-2 row-reverse d-inline-block hs-btn-cancel-small hs-fs-14"
                onClick={handleModalClose}
              >
                Cancel
              </Button>
              <HButton buttonClassName="hs-fs-16 px-3 mt-2" loading={addBtnLoading} onClick={addPhoneFields} size="s">
                Configure
              </HButton>
            </Space>
          </div>
        </Space>
      )}
    </>
  );

  return (
    <>
      <span
        onClick={() => {
          if (disabled) return;
          setConfigurePhoneModalOpen(true);
          if (fieldsOption && Object.keys(fieldsOption).length === 0) {
            fetchOnlyPhoneFields(appProperties, currentModuleReturnedByApp)
              .then((response) => {
                if (response) {
                  let filterPhoneOptionsArray = ConstructFieldsList(response);
                  if (filterPhoneOptionsArray) {
                    setPhoneFields(filterPhoneOptionsArray);
                  }
                }
              })
              .finally(() => {
                // setToNumberSelectLoading(false);
              });
          }
        }}
        className={`actionIconsSpriteForSideBar configurePhoneSettingsIcon display-inline-block ${disabled ? "cursor-disabled" : ""}`}
      ></span>

      <CommonModal
        modalCloseIcon={true}
        contentSpaceSize="large"
        open={configurePhoneModalOpen}
        doOnClose={handleModalClose}
        mask={true}
        header={
          <div>
            <div className="hs-fw-500 hs-fs-16">Phone Configuration</div>
            <div className="hs-fs-12 hs-color-light-grey-2">
              Configure 'To Phone' for
              <span className="text-capitalize ms-1"> {currentModuleReturnedByApp} module</span>
            </div>
          </div>
        }
        body={configurePhoneModalBody}
        okButtonProps={false}
        cancelButtonProps={false}
        modalCustomClassName={"phone-configuration-modal"}
        width={"auto"}
        styles={{
          mask: { backgroundColor: "rgb(163, 163, 163, 0.2)" },
          content: {
            boxShadow: "rgba(169, 169, 169, 0.366) 0px 13px 61px 0px",
          },
        }}
        centered
      />
    </>
  );
};

export const NotFoundContent = ({ content }) => {
  return (
    <>
      <Empty image={null} description={<span className="empty-content">{content}</span>}></Empty>
      {/* <div className="w-100 m-auto notDataFound d-flex align-items-center justify-content-center">
        {content}
      </div> */}
    </>
  );
};
export const EmptyListView = ({ icon, tagLineOne, tagLineTwo, tagHeight }) => {
  return (
    <>
      <div style={{ height: tagHeight }}>
        <div className="d-flex flex-grow-* flex-column align-items-center justify-content-center h-100">
          <div className={icon}></div>
          <div className="d-flex flex-column align-items-center">
            <span className="hs-fs-16 hs-color-dark-grey mt-1">{tagLineOne}</span>
            <span className="hs-fs-12 hs-text-muted mt-1">{tagLineTwo}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export const ModalEmptyListView = ({ icon, tagLineOne, tagHeight }) => {
  return (
    <>
      <div style={{ height: tagHeight }}>
        <div className="d-flex flex-grow-* flex-column align-items-center justify-content-center h-100">
          <div className={icon}></div>
          <div className="d-flex flex-column align-items-center">
            <span className="hs-fs-14 fw-normal opacity-50 mt-1 mb-2">{tagLineOne}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export const CommonModal = (props) => {
  const {
    okButtonProps,
    cancelButtonProps,
    doOnClose,
    header,
    modalCloseIcon,
    body,
    contentSpaceSize,
    mask,
    modalCustomClassName,
  } = props;
  const headerClasses = {
    large: "fs-4 fw-medium",
    small: "fs-6 fw-light",
  };

  return (
    <Modal
      {...props}
      className={`${modalCustomClassName ? modalCustomClassName + " " : "hs-min-w-350 "}` + props?.className}
      onCancel={doOnClose && doOnClose}
      centered
      closeIcon={null}
      mask={mask ?? false}
      maskClosable={false}
      footer={null}
    >
      <div className="d-flex justify-content-between align-items-start">
        <span className={headerClasses[contentSpaceSize]}>{header}</span>
        {modalCloseIcon && (
          <div onClick={doOnClose && doOnClose} className={"actionIconsSprite mediumSprite closeIconBig ms-2"} />
        )}
      </div>
      <Space size={contentSpaceSize ?? "large"} className="w-100 h-100 modalContent" direction="vertical">
        {body}
        {cancelButtonProps || okButtonProps ? (
          <div className="d-flex justify-content-end pb-3">
            <div className="d-flex align-items-center gap-4">
              {cancelButtonProps && (
                <Button
                  danger={cancelButtonProps?.danger ?? true}
                  {...cancelButtonProps}
                  className={`hs-border-10 big-button hs-fs-16 px-3 ${cancelButtonProps?.className}`}
                >
                  <span className="px-3">{cancelButtonProps?.buttonText}</span>
                </Button>
              )}
              {okButtonProps && (
                <Button
                  {...okButtonProps}
                  className={`hs-bg-violet hs-border-10 big-button text-white hs-fs-16 px-3 ${okButtonProps?.className}`}
                >
                  <span className="px-3">{okButtonProps?.buttonText}</span>
                </Button>
              )}
            </div>
          </div>
        ) : null}
      </Space>
    </Modal>
  );
};

export const DeleteComponent = (props) => {
  const {
    record,
    confirmDeleteIcon,
    confirmDeleteBtnName,
    confirmDeleteComponentTitle,
    confirmDeleteComponent,
    handleDelete, // This is a function that should returns a promise and should be resolved or rejected
    modalOpen,
    setModalOpen,
    showLoadingOnly,
    showDoNotShowAgain,
    hideDeleteButton,
  } = props;
  const [loading, setLoading] = useState(false);
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  const closeModal = () => {
    setModalOpen(false);
  };

  const handleDeleteClass = (record) => {
    if (doNotShowAgain) {
      localStorage.setItem("dripCampaignStepRemoveModal", "true");
    }
    setLoading(true);
    Promise.resolve(handleDelete(record))?.finally(() => {
      setModalOpen(false);
      setLoading(false);
    });
  };

  return (
    <>
      <Modal
        className="confirmDeleteModal"
        data-cy="confirm-delete-modal"
        maskClosable={false}
        open={modalOpen}
        onCancel={closeModal}
        width={400}
        centered
        closeIcon={null}
        wrapProps={{
          onClick: (e) => e.stopPropagation(),
        }}
        footer={
          showLoadingOnly ? (
            <></>
          ) : (
            <div className="d-flex align-items-center justify-content-between mt-2 w-100">
              <div
                className={`d-flex align-items-center justify-content-${hideDeleteButton === true ? "center" : "start"} ${
                  hideDeleteButton === true ? "w-100" : "w-50"
                }`}
              >
                <Button
                  className="hs-w-95 h-45 hs-fs-16 hs-button-v-cancel"
                  data-cy="cancel-in-delete-option"
                  onClick={() => {
                    setModalOpen(false);
                  }}
                  style={{ fontWeight: 600 }}
                >
                  Cancel
                </Button>
              </div>
              {hideDeleteButton !== true ? (
                <div className="w-50 d-flex align-items-center justify-content-end">
                  <Button
                    loading={loading}
                    className="w-100 h-45 confirmDeleteBtn hs-fs-16"
                    data-cy="confirm-delete"
                    onClick={() => handleDeleteClass(record)}
                  >
                    {confirmDeleteBtnName}
                  </Button>
                </div>
              ) : (
                <></>
              )}
            </div>
          )
        }
      >
        {showLoadingOnly ? (
          <div className="d-flex justify-content-center align-items-center">
            <div className="actionIconsSprite search-loading" />
          </div>
        ) : (
          <>
            <Row>
              <Col span={22}>
                <div className="d-flex align-items-center">
                  <div className={`${confirmDeleteIcon} actionIconsSprite me-4`} data-cy="confirm-delete-icon"></div>
                </div>
              </Col>
            </Row>
            <div style={{ fontSize: "16px", fontWeight: 600 }} className="mb-1" data-cy="confirm-delete-title">
              {confirmDeleteComponentTitle}
            </div>
            <div className="pb-3" data-cy="confirm-delete-description">
              {confirmDeleteComponent}
            </div>
            {showDoNotShowAgain && (
              <Checkbox
                rounded={false}
                item={{ label: "Don't show again" }}
                onChange={(e) => setDoNotShowAgain(e.target.checked)}
              />
            )}
          </>
        )}
      </Modal>
    </>
  );
};
export const removeKeysFromUrlParams = (key) => {
  const url = new URL(window.location.href);

  // Get the search parameters
  const params = new URLSearchParams(url.search);

  if (Array.isArray(key)) {
    key.forEach((keyString) => {
      params.delete(keyString);
    });
  } else {
    params.delete(key);
  }

  // Construct the new URL
  const newUrl = `${url.origin}${url.pathname}?${params.toString()}`;

  // Update the URL in the browser without reloading
  window.history.pushState({}, "", newUrl);
};

export const Logo = React.memo((props) => {
  const { appLogo } = props;
  return (
    <div className="d-flex gap-2">
      <Image
        className="right-logo"
        src={appLogo}
        preview={false}
        draggable={false}
        height={45}
        style={{ width: "auto" }}
      />
    </div>
  );
});

export const getLabelForTemplate = (friendlyName, templateType, content) => {
  return (
    <Row className="template-item-label">
      <Col span={19}>
        <div className="d-flex gap-2 align-items-center" data-cy="template-item-container">
          <Text ellipsis data-cy="template-friendly-name">
            {friendlyName}
          </Text>
          {templateType && (
            <div
              className={`staticIconsSprite template-service-indicator-icon template-service-indicator-icon-${templateType}`}
              data-cy={`template-service-indicator-icon-${templateType}`}
            />
          )}
        </div>
      </Col>
      <Col span={4} style={{ visibility: "hidden" }} className="savedTemplateEye">
        <div className="d-flex justify-content-end">
          <Tooltip placement={"top"} title={content}>
            <div data-cy="preview-Template-EyeIcon" className="actionIconsSprite  previewTemplateEyeIcon " />
          </Tooltip>
        </div>
      </Col>
    </Row>
  );
};

export const RenderOptionLabel = ({ label }) => {
  return (
    <div className={`marquee-container ${label?.length > 15 ? "active" : ""}`}>
      <span className={`marquee-option w-100 `}>{label}</span>
    </div>
  );
};

export const findServiceById = (appProperties, serviceIdToFind) => {
  if (!appProperties?.apps) return;
  return Object.values(appProperties?.apps)
    .flat() // Flatten all categories into a single array
    .find((service) => service.serviceId === serviceIdToFind);
};

export function TenDLCStatus({ appProperties, brandStatus, a2pStatus, campaignStatus, serviceName }) {
  return (
    <div>
      {appProperties.accountStatus === 11 ? (
        <div className="tenDlcLink" style={{ background: "#FFEBEE" }}>
          <ExclamationCircleOutlined className="pe-2 " style={{ fontSize: "1.5rem", color: "#F44336" }} />
          Due to low credits, your account has been suspended. To resume messaging, please recharge now
          <BuyFunds />.
        </div>
      ) : brandStatus === "PENDING" ? (
        <div className="tenDlcLink">
          <ExclamationCircleOutlined className="pe-2 " style={{ fontSize: "1.5rem", color: "#FF9800" }} />
          Your brand registration has been submitted successfully; renewal may take up to 7 days.
        </div>
      ) : a2pStatus?.includes("Pending") || campaignStatus === "IN_PROGRESS" ? (
        <div className="tenDlcLinkPending">
          <ClockCircleOutlined
            style={{
              fontSize: "1.6rem",
              color: "#FFB946",
              paddingRight: "0.5rem",
            }}
          />
          <div>
            Your 10DLC form has been successfully submitted. Please anticipate a review period of 10 to 15 days. For any
            inquiries, contact us at
            <a
              target="_blank"
              rel="noreferrer"
              href={`mailto:${ASSIST_MAIL}`}
              style={{ paddingLeft: 5, color: "#009EFD" }}
            >
              {ASSIST_MAIL}.
            </a>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export const isCurrentUserHasUserRolePermission = (appProperties) => {
  if (appProperties) {
    const currentUserObj = appProperties?.licenseObj?.allLicensedUserDetails?.find(
      (user) => user?.remoteUserId === appProperties?.userId
    );
    const roleId = currentUserObj?.roleId;
    const userRoleKey = Object?.entries(appProperties?.rolesBasedObject)?.find(([_, value]) => value === "USER")?.[0];
    if (roleId?.toString() === userRoleKey) {
      return true;
    }
  }
  return false;
};

export const checkTheCurrentCustomerIsInTrialPeriod = (appProperties) => {
  const licenseStatus = appProperties?.licenseObj?.licenseDetails?.licenseStatus;
  return [2, 4, 5].includes(licenseStatus);
};

export const checkTheCurrentCustomerIsNotPurchasedUser = (appProperties) => {
  const licenseStatus = appProperties?.licenseObj?.licenseDetails?.licenseStatus;
  return [2, 4, 5, 11, 24].includes(licenseStatus);
};

export const RenderNameWithEllipsis = ({ content, maxWidth = "250px" }) => {
  return (
    <Tooltip placement="top" title={content}>
      <Text ellipsis style={{ maxWidth: maxWidth, minWidth: "50%" }}>
        {content}
      </Text>
    </Tooltip>
  );
};

export const ClickToCallButton = (props) => {
  const { recordId, phone, module, fromNumber, contactName } = props;
  const [appProperties, setAppProperties] = useContext(AppContext);
  const [callProperties, setCallProperties] = useVoiceContext();
  const [upgradeAlertPopup, setUpgradeAlertPopup] = useState(false);

  const handleClickToCall = (event) => {
    event.stopPropagation();
    if (getCurrentFeature(appProperties) === "Message") {
      setUpgradeAlertPopup(true);
      return;
    }
    initiateOutboundCall(
      phone,
      recordId,
      module,
      appProperties,
      setAppProperties,
      fromNumber,
      callProperties,
      setCallProperties,
      contactName
    );
  };
  return (
    <>
      {upgradeAlertPopup && (
        <UpgradeAlertPopup upgradeAlertPopup={upgradeAlertPopup} setUpgradeAlertPopup={setUpgradeAlertPopup} />
      )}
      <div
        key={fromNumber + "_" + phone}
        onClick={(event) => {
          handleClickToCall(event);
        }}
        className="call-action-icons logs-clickToCall-Icon cursor-pointer"
      />
    </>
  );
};

export function DateAndTimePickerComponent({ scheduledDate, setScheduledDate, scheduledTime, setScheduledTime }) {
  const disabledTime = () => {
    const now = dayjs();
    const next15Minutes = dayjs(now).add(15, "minutes");
    const isSameDate = now.isSame(dayjs(scheduledDate), "date");
    return {
      disabledHours: () => {
        if (isSameDate) {
          return [...Array(next15Minutes.hour()).keys()];
        }
        return [];
      },
      disabledMinutes: (selectedHour) => {
        if (selectedHour === next15Minutes.hour() && isSameDate) {
          return [...Array(next15Minutes.minute()).keys()];
        }
        return [];
      },
      disabledSeconds: () => [],
    };
  };
  return (
    <div className="d-flex align-items-center justify-content-between mb-2">
      <div>
        <div className="hs-text-color hs-fs-12">Date</div>
        <DatePicker
          className="hs-border-grey hs-border-5"
          suffixIcon={null}
          superNextIcon={null}
          superPrevIcon={null}
          showSecond={null}
          variant="borderless"
          popupClassName="datePickerPanel"
          allowClear={false}
          value={scheduledDate}
          onChange={(e) => setScheduledDate(e)}
          showToday={false}
          disabledDate={false}
        />
      </div>
      <div>
        <div className="hs-text-color hs-fs-12">Time</div>
        <TimePicker
          className="ms-1 hs-border-grey hs-border-5"
          popupClassName="timePickerPopupPanel"
          disabledTime={disabledTime}
          suffixIcon={null}
          showNow={false}
          allowClear={false}
          value={scheduledTime}
          onChange={(e) => setScheduledTime(e)}
        />
      </div>
    </div>
  );
}

export const SuggestReply = React.forwardRef(
  ({ enabledCheck = true, appProperties, prompt, setMessageAreaLoading, setMessage, setIsAiGenerated, size }, ref) => {
    const { generateContent } = useAI();
    const handleSuggestReply = async (tone) => {
      if (enabledCheck) {
        setMessageAreaLoading(true);
        try {
          const integId = appProperties?.installedApps?.[0]?.integProps?.integId;
          const result = await generateContent(prompt, integId, appProperties, { tone });
          if (result.success) {
            setMessage(result.data);
            setIsAiGenerated(true);
            if (ref && ref.current) {
              ref.current.focus();
            }
          } else {
            console.error("Error fetching suggested reply:", result.error);
          }
        } catch (error) {
          console.error("Error fetching suggested reply:", error);
        } finally {
          setMessageAreaLoading(false);
        }
      }
    };

    return (
      <div className="d-flex align-items-center">
        <SuggestReplyButton handleSuggestReply={handleSuggestReply} size={size} />
      </div>
    );
  }
);

export const SuggestReplyButton = ({ handleSuggestReply, btnName, size }) => {
  const toneSuggestionItem = getToneSuggestionItems(handleSuggestReply);
  return (
    <HToolTip title={"Level up your message tone"}>
      <Dropdown menu={{ items: toneSuggestionItem }} placement="topLeft" trigger={["click"]}>
        <div
          className={`d-flex justify-content-between cursor-pointer ${size === "small" ? "hs-scale-0-8" : ""}`}
          data-cy="suggest-reply-btn"
        >
          <div className="actionIconsSprite announcement" />
          <div className="hs-fw-400 hs-color-violet cursor-pointer ps-1">{btnName}</div>
        </div>
      </Dropdown>
    </HToolTip>
  );
};
export const CreditsSuccessModal = (props) => {
  const { successModal, setSuccessModal } = props;

  const handleClickDomainUrl = () => {
    setSuccessModal(false);
  };
  return (
    <Modal
      title={
        <Row>
          <div className="d-flex justify-content-center w-100">
            <span
              className="d-flex justify-content-center actionIconsSprite successTickIcon"
              style={{
                width: 60,
                height: 60,
              }}
            ></span>
          </div>
        </Row>
      }
      centered
      width={425}
      onOk={() => {}}
      className="successPricingModel"
      closable={false}
      open={successModal}
      footer={null}
      zIndex={1009}
    >
      <>
        <div className="mt-4 mb-2">
          <Row>
            <div className="d-flex justify-content-center w-100">
              <span className="hs-fs-16 hs-fw-bolder hs-color-BlackRussian">You're All Set!</span>
            </div>
          </Row>
          <Row className="d-flex justify-content-center">
            <Col className="d-flex justify-content-center ms-3">
              <div className="hs-fs-14">
                Your credits have been added to HelloSend and will appear in our system shortly.
              </div>
            </Col>
          </Row>
        </div>

        <div className="d-flex justify-content-center justify-content-between">
          <Button className="hs-w-100 goToServicePricingBtn" onClick={handleClickDomainUrl}>
            Done
          </Button>
        </div>
      </>
    </Modal>
  );
};

export const MESSAGE_AREA_INFO_ALERTS = {
  whatsapp_disconnect_warning: {
    getMessage: (appProperties = {}) => (
      <>
        Scheduled Maintenance: Please revoke and re-scan your WhatsApp QR to ensure uninterrupted service —{" "}
        <Link
          baseUrl={"/settings/channels/personal_whatsapp?"}
          textClasses="hs-color-alert hs-fw-550 hs-fs-12 text-decoration-underline"
          appProperties={appProperties}
        >
          Re-scan now
        </Link>
      </>
    ),
    type: "alert",
    closable: true,
    animated: false,
    icon: true,
  },
};

export const MessageAreaInfo = ({
  message,
  type = "info",
  id,
  icon = false,
  animated = true,
  closable = false,
  onClose = () => {},
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    onClose();
  };

  if (!isVisible) return null;

  return (
    <div className="d-flex justify-content-center h-auto overflow-hidden">
      <div
        key={id}
        className={`d-flex hs-border-5 hs-message-area-${type} ${animated ? "hs-slide-top" : ""} text-white hs-h-2-5-rem h-100 w-100`}
      >
        <div className="w-100 d-flex align-items-center justify-content-center p-2 h-100 gap-1">
          {icon && (
            <div className="me-md-1 my-auto">
              <div className="d-flex justify-content-center">
                <div className={`staticIconsSprite alert-type-${type}-icon`}></div>
              </div>
            </div>
          )}
          <div className="w-100">
            <Text className={`my-auto hs-fw-400 hs-color-${type} hs-fs-13`}>{message}</Text>
          </div>
        </div>
        {closable && (
          <div className="d-flex justify-content-end align-items-center p-1 pe-3">
            <div className="actionIconsSprite2 close-icon-white" onClick={handleClose}></div>
          </div>
        )}
      </div>
    </div>
  );
};
export const DefaultAvatar = () => {
  return <div className={"h-100 w-100 avatarIcon rounded-circle staticIconsSprite"} />;
};
export const DefaultConversationAvatar = () => {
  return <div className="conversation-default-avatarIcon rounded-2 staticIconsSprite"></div>;
};

export const displayAgentComponent = (item, handleSelectTeamManager) => {
  return (
    <>
      <Row data-cy={`user-row-${item?.email}`}>
        <Col span={6} className="d-flex justify-content-center align-items-center">
          <CommonUserAvatar name={item?.firstName} icon={item?.avatar} size={40} />
        </Col>
        <Col span={16}>
          <div className="d-flex flex-column">
            <div className="d-flex flex-row align-items-center">
              <span className="fs-14-fw-500">{item?.firstName}</span>
              {item?.agentRoleId === 1 && (
                <div
                  className="actionIconsSprite team-manager-icon cursor-pointer"
                  data-cy={`manager-label-${item?.email}`}
                />
              )}
            </div>
            <span className="hs-color-light-grey-2 hs-fs-12">{item?.email}</span>
          </div>
        </Col>
        <Col span={2} className="d-flex justify-content-center align-items-center">
          <div
            data-cy={`manager-role-icon-${item?.email}`}
            className={`actionIconsSprite ${
              item?.agentRoleId === 1 ? "selected-team-manager-badge-icon" : "unselected-team-manager-badge-icon"
            } cursor-pointer`}
            onClick={() => handleSelectTeamManager(item?.osyncUserId)}
          />
        </Col>
      </Row>
    </>
  );
};

export const showFooterContentForSelect = (title, onClick) => {
  return (
    <>
      <Divider style={{ margin: 0 }} />
      <div
        className="d-flex gap-1 align-items-center flex-row p-2 cursor-pointer"
        onClick={onClick}
        data-cy="add-user-footer-btn"
      >
        <div className="hs-color-violet hs-fw-500">+</div>
        <div className="hs-color-violet hs-fw-500">{title}</div>
      </div>
    </>
  );
};
export const CustomerConsent = ({ hasNotAgreedWhileSubmit = false }) => {
  return (
    <span className={`hs-fs-12 ${hasNotAgreedWhileSubmit ? "hs-color-red hs-fw-bolder" : "hs-color-dark-grey"}`}>
      I agree to HelloSend's{" "}
      <a target="_blank" rel="noopener noreferrer" href="https://www.hellosend.com/terms-and-conditions">
        Terms of Service
      </a>{" "}
      and{" "}
      <a target="_blank" rel="noopener noreferrer" href="https://www.hellosend.com/privacy-policy">
        Privacy Policy
      </a>
    </span>
  );
};

export const getLogoClassByService = (serviceName, smallLogo = false) => {
  const logoMap = {
    Pipedrive: smallLogo ? "pipe-drive-logo-small" : "pipe-drive-logo",
    Teams: smallLogo ? "teams-logo-small" : "teams-logo",
    OAppS: smallLogo ? "no-integration-logo-small" : "no-integration-logo",
    HelloSend: smallLogo ? "no-integration-logo-small" : "no-integration-logo",
    HubSpot: "hubspot-logo",
    "Zoho CRM": smallLogo ? "zoho-crm-logo-small" : "zoho-crm-logo",
    "Zoho Desk": "zoho-desk-logo",
    Salesforce: "salesforce-logo",
    Zendesk: smallLogo ? "zendesk-logo-small" : "zendesk-logo",
  };

  return `applicationLogosSprite ${logoMap[serviceName] || "default-logo"}`;
};
export const getDaysDifference = (startDay, endDay) => {
  var millisBetween = startDay.getTime() - endDay.getTime();
  var days = millisBetween / (1000 * 3600 * 24);
  return Math.round(Math.abs(days));
};

export const phoneNumberAccess = {
  SYSTEM_DEFAULT: 0,
  ALL_NUMBERS: 1,
  ASSIGNED_NUMBERS: 2,
  TEAM_ASSIGNED_NUMBERS: 3,
};

export const isAlphabet = (char) => {
  return /^\p{L}$/u.test(char);
};

export const getContactAvatar = (resp, customerDisplayNameObject, appProperties, hideServiceIndicator = false) => {
  const isFirstCharAlphabet = isAlphabet(customerDisplayNameObject?.iconLetter);
  return (
    <div className="position-relative">
      <div className="ms-1 hs-bg-light-orange rounded-circle d-flex align-items-center justify-content-center list-row-avatar">
        {resp?.avatar ? (
          <Avatar rootClassName="w-100 h-100" src={resp?.avatar} />
        ) : !customerDisplayNameObject?.isPhoneNumber && isFirstCharAlphabet ? (
          <span className="hs-color-dark-orange hs-fw-600 hs-fs-18">{customerDisplayNameObject?.iconLetter}</span>
        ) : (
          <DefaultAvatar />
        )}
      </div>
      {resp?.rightServiceId && !hideServiceIndicator && (
        <div className="contact-service-indicator-outer-circle" data-cy="connected-channels-icons">
          <ServiceIndicationIcon serviceName={findServiceById(appProperties, resp?.rightServiceId)?.name} />
        </div>
      )}
    </div>
  );
};

export const ServiceIndicationIcon = ({ serviceName }) => {
  return (
    <>
      {serviceName && (
        <div
          className={`staticIconsSprite contact-service-indicator-icon shadow contact-service-indicator-icon-${serviceName
            ?.toLowerCase()
            ?.replace(/ /g, "_")}`}
          data-cy={`indicator-icon-${serviceName?.toLowerCase()?.replace(/ /g, "_")}`}
        />
      )}
    </>
  );
};

export const getDisplayNameOfCustomer = (contactData) => {
  let customerNameString = [contactData?.firstName, contactData?.lastName].filter(Boolean).join(" ");
  let isPhoneNumber = false;
  if (!customerNameString) {
    isPhoneNumber = true;
    customerNameString = contactData?.orgCustomer;
  }
  // this is trimmed because of the issue of the space in the name
  customerNameString = customerNameString?.trim();
  let iconLetter = isPhoneNumber ? "#" : customerNameString?.slice(0, 1)?.toUpperCase();

  return {
    displayName: customerNameString,
    iconLetter: iconLetter,
    isPhoneNumber: isPhoneNumber,
  };
};

export const DropOverlay = ({ isDraggingOver, dragOverlayRef }) => {
  if (!isDraggingOver) return null;
  return (
    <div
      ref={dragOverlayRef}
      className="d-flex align-items-center justify-content-center position-absolute top-0 bottom-0 hs-left-right-0 hs-z-index-god pointer-events-none hs-bg-light-grey-1 hs-border-10"
    >
      <div className="text-center">
        <div className="hs-fs-18 hs-fw-600 hs-color-violet mb-2">Drop files to upload</div>
        <div className="hs-fs-14 hs-color-dark-grey">Release to upload files</div>
      </div>
    </div>
  );
};
